import { Heading } from '@chakra-ui/react';
import React from 'react';

import { CreditFacilityGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { PortfolioLtvChartTemplateForOrganization } from './PortfolioLtvChartTemplateForOrganization';
import { colors } from 'packages/common-frontend/colors';
import { HighlightBox } from 'packages/common-frontend/components/HighlightBox';

type PortfolioOverivewRiskContainerProps = {
  organizationId: string;
  creditFacilities: Pick<CreditFacilityGQLType, 'id' | 'slug'>[];
};
export const PortfolioOverivewRiskContainer = ({
  organizationId,
  creditFacilities,
}: PortfolioOverivewRiskContainerProps) => {
  return (
    <>
      <Heading as="h3" fontSize="24px" mb="24px">
        LTV
      </Heading>
      <HighlightBox backgroundColor={colors.millet[50]}>
        <PortfolioLtvChartTemplateForOrganization
          organizationId={organizationId}
          creditFacilities={creditFacilities}
        />
      </HighlightBox>
    </>
  );
};
